export const pluginId = 'tree-menus'
